module.exports = __webpack_public_path__ + "img/SKMJ_ex2.8a417870.jpg";